import * as React from 'react';
import { TableMapper } from '../../../shared';
export var TableHeaderTitlesMapperBase = function () { return (React.createElement(TableMapper, { rampName: "HeaderTitleBase" })); };
